module.exports = __webpack_public_path__ + "img/d2.665710f2.webp";